module.exports = __webpack_public_path__ + "static/media/logo.39daf485.png";